import { getCookie, simulateAsyncOperation } from 'mmbclient/Common/CommonFunctions';
import { checkSession, getClientDetail, getConsigneeDetails, getCountryDetails, getPincodeDetails, getServiceDetails } from 'mmbclient/Common/CommonService';
import { API_PATH, APP_TYPE_COOKIE_NAME, CREDIT_BOOK_PICKUP_REQUEST_PATH, GLOBAL_CONTEXT, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, PAGE_LOADING_TIME, US, USER_TYPE_COOKIE_NAME, WALLET } from 'mmbclient/Common/CommonVariable';
import CircularSpinner from 'mmbclient/Components/CircularSpinner';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import './CreditPickUpRequest.css'
import { use } from 'react';
// import { getClientBalance } from 'mmbclient/Common/CommonRazorPay';

export const CreditPickUpRequest = () => {

    const store = useContext(GLOBAL_CONTEXT);
    const wallet = useContext(WALLET);

    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState('');
    const [showModal, setShowModal] = useState(false);

    const [loading, setLoading] = useState(false);

    const [service, setService] = useState(['Select...']);
    
    const [pincodeList, setPincodeList] = useState([]);
    const [country, setCountry] = useState([]);
    const [receiver, setReceiver] = useState([]);

    const [filteredOriginPincodes, setFilteredOriginPincodes] = useState([]);
    const [filteredDestPincodes, setFilteredDestPincodes] = useState([]);
    const [filteredCountries, setFilteredCountries] = useState([]);
    const [checked, setChecked] = useState(false);


    // New states for keyboard navigation for origin pincode, destination pincode and destination country
    const [activeOriginIndex, setActiveOriginIndex] = useState(-1);
    const [activeDestIndex, setActiveDestIndex] = useState(-1);
    const [activeCountryIndex, setActiveCountryIndex] = useState(-1);


    const Select = 'Select...';

    const [formValues, setFormValues] = useState({
        domInt: 'dom',
        awbNo: '',
        service: Select,
        originPincode: '',
        originCity: '',
        destPincode: '',
        destCity: '',
        destCountry: '',
        content: '',
        otherContent: '',
        insuranceValue: '',
        packets: '',
        weight: '',
        docType: 'dox',
        nonDoxDetails: [{ id: Date.now(), weight: '', len: '', wid: '', ht: '' }],
        receiverName: '',
        receiverAddress: '',
        receiverContact: '',
        receiverPincode: '',
        receiverCity: '',
        receiverState: '',
        receiverCountry: '',
        printShiper: JSON.stringify(checked),
        clientCode: getCookie(USER_TYPE_COOKIE_NAME) === US ? getCookie(LOGIN_COOKIE_NAME).split(LOGIN_COOKIE_NAME_SPLITBY)[1] : '',
        userType: getCookie(APP_TYPE_COOKIE_NAME)
    });

    // Create a ref for the other content input
    const otherContentRef = useRef(null);

    useEffect(()=>{
     //   getClientBalance(wallet);
    },[wallet.walletAmount]);

    // Debounce utility
    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }

    // Filter functions for origin and destination pincodes
    const filterOriginPincodes = (value) => {
        if (!value) {
            setFilteredOriginPincodes([]);
            return;
        }
        // const filtered = pincodeList.filter(item => item.startsWith(value));
        const filtered = pincodeList.filter(pin => pin.startsWith(value));

        setFilteredOriginPincodes(filtered);
    };

    const filterDestPincodes = (value) => {
        if (!value) {
            setFilteredDestPincodes([]);
            return;
        }
        // const filtered = pincodeList.filter(item => item.startsWith(value));
        const filtered = pincodeList.filter(pin => pin.startsWith(value));
        setFilteredDestPincodes(filtered);
    };

    const filterCountries = (value) => {
        if (!value) {
            setFilteredCountries([]);
            return;
        }
        const filtered = country.filter(item =>
            item.toUpperCase().startsWith(value.toUpperCase())
        );
        setFilteredCountries(filtered);
    };

    // Create debounced versions so filtering isn’t too aggressive
    const debouncedFilterOrigin = useMemo(() => debounce(filterOriginPincodes, 300), [pincodeList]);
    const debouncedFilterDest = useMemo(() => debounce(filterDestPincodes, 300), [pincodeList]);
    const debouncedFilterCountry = useMemo(() => debounce(filterCountries, 300), [country]);

    useEffect(() => {
        // Fetch data from server
        const fetchData = async () => {

            setLoading(true);

            try {
                await Promise.all([
                    loadServiceDetails(store),
                    loadPincodeDetails(store),
                    loadCountryDetails(store),
                    loadAllReceiverDetails(store),
                    simulateAsyncOperation(PAGE_LOADING_TIME),
                ]);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleBlurAwbNo = async () => {

        try {
            if (!formValues.awbNo) return;
            if (!formValues.clientCode) return;

            checkSession(store);
            if (!getCookie(LOGIN_SESSION_NAME)) {
                return;
            }

            setLoading(true);

            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            const Data = "Data";
            if (c.length === 4) {
                let query = {};
                if (getCookie(USER_TYPE_COOKIE_NAME) === US) {
                    query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "awbNo": formValues.awbNo, "clientCode": formValues.clientCode };
                }
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query)
                    })
                };
                const path = API_PATH + CREDIT_BOOK_PICKUP_REQUEST_PATH + "getdata";
                const res = await fetch(path, requestOptions);
                const data = await res.json();
                const response = JSON.parse(data)[0][Data];

                if (response.length > 0 && response !== "Result Not Found") {
                    const firstEntry = response[0]; // Use the first object for general form fields

                    if (firstEntry.awb_no === formValues.awbNo && firstEntry.true === 'true') {
                        handleReset(formValues.awbNo);
                    } else {

                        let originCity = '';
                        for (const currentValue of pincodeMaster) {
                            const pincode = currentValue.pin_code;
                            const cityName = currentValue.city_name;
                            if (pincode === firstEntry.origin_pincode) {
                                originCity = cityName;
                                break;
                            }
                        }

                        let destCity = '', receiverPincode = '', receiverCity = '', receiverState = '', receiverCountry = '';
                        for (const currentValue of pincodeMaster) {
                            const pincode = currentValue.pin_code;
                            const cityName = currentValue.city_name;
                            const cityCode = currentValue.city_code;
                            const stateCode = currentValue.state_code;
                            const countryCode = currentValue.country_code;
                            if (pincode === firstEntry.destination_pincode) {
                                destCity = cityName;
                                receiverPincode = pincode;
                                receiverCity = cityCode;
                                receiverState = stateCode;
                                receiverCountry = countryCode;
                                break;
                            }
                        }

                        const contentListExceptOther = ["BOOKS", "CAMERA", "CLOTHES", "COMPUTER", "DOCUMENTS", "EARPHONE", "GIFT ITEMS", "LAPTOP", "PRINTERS", "SHOES", "WRIST WATCH"];
                        let content = '', otherContent = '';
                        if (firstEntry.content === '') {
                            content = Select;
                        } else {
                            content = contentListExceptOther.includes(firstEntry.content) ? firstEntry.content : "OTHER";
                            otherContent = contentListExceptOther.includes(firstEntry.content) ? '' : firstEntry.content;
                        }

                        // setFormValues((prevValues) => ({
                        //     ...prevValues,
                        //     nonDoxDetails: [{ id: Date.now(), weight: '', len: '', wid: '', ht: '' }]
                        // }));

                        setFormValues(prevValues => ({
                            ...prevValues,
                            domInt: firstEntry.do_in === 'DO' ? 'dom' : 'int',
                            service: firstEntry.service_group_code || Select,
                            originPincode: firstEntry.origin_pincode || "",
                            originCity: originCity,
                            destPincode: firstEntry.destination_pincode || "",
                            destCity: destCity,
                            destCountry: firstEntry.destination_country || "",
                            content: content,
                            otherContent: otherContent,
                            insuranceValue: firstEntry.insurance_value || "",
                            packets: firstEntry.packets || "",
                            weight: firstEntry.actual_weight || "",
                            docType: firstEntry.document_type === 'D' ? "dox" : "non-dox",
                            nonDoxDetails: response.map((item, index) => ({
                                id: index + 1,
                                ht: item.height || "",
                                wid: item.width || "",
                                len: item.length || "",
                                weight: item.act_wt || ""
                            })),
                            receiverName: firstEntry.consignee_name || "",
                            receiverAddress: firstEntry.consignee_address || "",
                            receiverContact: firstEntry.consignee_phone || "",
                            receiverPincode: receiverPincode,
                            receiverCity: receiverCity,
                            receiverState: receiverState,
                            receiverCountry: receiverCountry,
                        }));
                    }

                } else {
                    handleReset(formValues.awbNo);
                    setModalMessage('Error : Awb No. not exists in Stock');
                    setModalType('danger');
                    setShowModal(true);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setModalMessage('Failed to fetch data. Please try again.');
            setModalType('danger');
            setShowModal(true);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        if (name === 'content' && value === 'OTHER') {
            // Use setTimeout to focus on the other content input
            setTimeout(() => {
                if (otherContentRef.current) {
                    // Focus on the other content input when "OTHER" is selected
                    otherContentRef.current.focus();
                }
            }, 0);
        }

        if (name.startsWith('detail-')) {   // Check if the input is for nonDoxDetails
            const [, id, field] = name.split('-'); // Get id and field type (e.g., weight, len, wid, ht)
            setFormValues(prevValues => ({
                ...prevValues,
                nonDoxDetails: prevValues.nonDoxDetails.map(detail => {
                    if (detail.id === parseInt(id)) {
                        if (field === 'weight') {
                            if (value === '' ||
                                (/^(\d{1,12})(\.\d{0,3})?$/.test(value))) {
                                return { ...detail, [field]: value };
                            }
                        } else if (field === 'len') {
                            if (value === '' ||
                                (/^(\d{1,12})(\.\d{0,3})?$/.test(value))) {
                                return { ...detail, [field]: value };
                            }
                        } else if (field === 'wid') {
                            if (value === '' ||
                                (/^(\d{1,12})(\.\d{0,3})?$/.test(value))) {
                                return { ...detail, [field]: value };
                            }
                        } else if (field === 'ht') {
                            if (value === '' ||
                                (/^(\d{1,12})(\.\d{0,3})?$/.test(value))) {
                                return { ...detail, [field]: value };
                            }
                        }
                    }
                    return detail; // Return unchanged detail
                })
            }));
        } else if (name === 'awbNo') {
            if (value === '' ||
                (value.length <= 25 && /^[a-zA-Z0-9]*$/.test(value))) {
                setFormValues({
                    ...formValues,
                    [name]: value.toUpperCase()
                });
            }
        } else if (name === 'printShiper') {
            setChecked(event.target.checked)
            let chk = "";
            if (JSON.stringify(checked) === "false") {
                chk = "true";
            }

            setFormValues({
                ...formValues,
                [name]: chk
            });

        } else if (name === 'originPincode') {
            if (value === '' ||
                (value.length <= 6 && /^\d{0,6}$/.test(value))) {
                setFormValues({
                    ...formValues,
                    [name]: value
                });
                debouncedFilterOrigin(value);
            }
        } else if (name === 'destCountry') {
            setFormValues({
                ...formValues,
                [name]: value,
                'receiverPincode': '',
                'receiverCity': '',
                'receiverState': '',
                'receiverCountry': value
            });
            debouncedFilterCountry(value);
        } else if (name === 'destPincode') {
            if (value === '' ||
                (value.length <= 6 && /^\d{0,6}$/.test(value))) {
                setFormValues({
                    ...formValues,
                    [name]: value
                });
                debouncedFilterDest(value);
            }
        } else if (name === 'packets') {
            if (value === '' ||
                (value.length <= 3 && /^[1-9][0-9]*$/.test(value))) {
                setFormValues({
                    ...formValues,
                    [name]: value
                });
            }
        } else if (name === 'weight') {
            if (value === '' ||
                (/^(\d{1,12})(\.\d{0,3})?$/.test(value))) {
                setFormValues({
                    ...formValues,
                    [name]: value
                });
            }
        } else if (name === 'insuranceValue') {
            if (value === '' ||
                (/^(\d{1,13})(\.\d{0,2})?$/.test(value))) {
                setFormValues({
                    ...formValues,
                    [name]: value
                });
            }
        } else if (name === 'content') {
            // if (value === Select) {
            setFormValues({ ...formValues, [name]: value });
            //}
        } else if (name === 'otherContent') {
            if (value === '' ||
                (value.length <= 60 && /^[a-zA-Z0-9\s]*$/.test(value))) {
                setFormValues({
                    ...formValues,
                    [name]: value
                });
            }
        } else if (name === 'receiverContact') {
            // Contact number validation: only 10 digits
            if (value === '' || (value.length <= 10 && /^\d{0,10}$/.test(value))) {
                setFormValues({ ...formValues, [name]: value });
            }
        } else if (name === 'receiverName') {
            // Name validation: only letters, digits, spaces, max length 80
            if (value === '' || (value.length <= 80 && /^[a-zA-Z0-9\s]*$/.test(value))) {
                setFormValues({ ...formValues, [name]: value });
            }
        } else if (name === 'receiverAddress') {
            // Address validation: regex and max length 100
            const addressRegex = /^[a-zA-Z0-9\s,.#-]*$/; // Customize regex as needed
            if (value === '' || (value.length <= 100 && addressRegex.test(value))) {
                setFormValues({ ...formValues, [name]: value });
            }
        } else {
            setFormValues({
                ...formValues,
                [name]: value
            });
        }
    };

    // Function to select a pincode suggestion for origin
    const selectOriginPincode = (item) => {
        // setFormValues({ ...formValues, originPincode: item });
        for (const currentValue of pincodeMaster) {
            const pincode = currentValue.pin_code;
            const cityName = currentValue.city_name;
            if (item === pincode) {
                setFormValues({
                    ...formValues,
                    "originPincode": pincode,
                    "originCity": cityName
                });
                break;
            }
        }
        setFilteredOriginPincodes([]);
    };

    // Function to select a pincode suggestion for destination
    const selectDestPincode = (item) => {
        console.log(pincodeList);
        for (const currentValue of pincodeMaster) {
            const pincode = currentValue.pin_code;
            const cityName = currentValue.city_name;
            const cityCode = currentValue.city_code;
            const stateCode = currentValue.state_code;
            const countryCode = currentValue.country_code;
            if (pincode === item) {
                console.log('in if true',pincode);
                setFormValues(prev=>({
                    ...prev,
                    'destPincode':pincode,
                    'destCity':cityName,
                    'receiverPincode':pincode,
                    'receiverCity':cityCode,
                    'receiverState':stateCode,
                    'receiverCountry':countryCode
                }))
                // setFormValues({
                //     ...formValues,
                //     'destPincode': pincode,
                //     'destCity': cityName,
                //     'receiverPincode': pincode,
                //     'receiverCity': cityCode,
                //     'receiverState': stateCode,
                //     'receiverCountry': countryCode
                // });
                break;
            }
        }
        setFilteredDestPincodes([]);
    };

    // Function to select a country suggestion for destination
    const selectCountry = (item) => {
        setFormValues({ ...formValues, destCountry: item });
        setFilteredCountries([]);
        setActiveCountryIndex(-1);
    };


    // Function to validate the country when input loses focus
    const handleBlurCountry = (name) => {
        if (name === 'destCountry') {
            const isValidCountry = country.some(countryItem =>
                countryItem === formValues.destCountry
            );
            if (!isValidCountry) {
                // Optionally reset or clear the input
                setFormValues({
                    ...formValues,
                    [name]: '', // Clear the input if not valid
                    'receiverPincode': '',
                    'receiverCity': '',
                    'receiverState': '',
                    'receiverCountry': ''
                });
                // Or show an error message, e.g., set an error state
            }
        }
    };

    const handleBlurReceiver = (name) => {
        if (name === 'receiverContact') {
            setFormValues({
                ...formValues,
                'receiverAddress': '',
                receiverName: ''
            });
            for (const item of receiver) {
                if (formValues.receiverContact === item.contact_no) {
                    setFormValues({
                        ...formValues,
                        'receiverName': item.name,
                        'receiverAddress': item.address // Clear the input if not valid
                    });
                    break;
                }
            }
        }
    };

    const [isValidating,setIsValidating] = useState(false);
    const handleBlur = (type) => {
        // Function to run on blur

        // const { name,value } = event.target;

        // if (isValidating) return;

        // try {

        //     const isValid = pincodeMaster.find(
        //         pin => pin.pin_code === value
        //     );

        //     if (isValid===undefined) {
        //         setIsValidating(true);
        //         if(name === 'originPincode'){
        //             setFormValues(prev=>({
        //                 ...prev,
        //                 'originCity': '',
        //             }))
        //         }else if(name==='destPincode'){
        //             setFormValues(prev=>({
        //                 ...prev,
        //                 'destCity': '',
        //             }));
        //         }
        //         setTimeout(() => {
        //             event.target.focus();
        //             setIsValidating(false);
        //         }, 0);
        //     }else{
        //         setIsValidating(true);
        //         if(name === 'originPincode'){
        //             // console.log("from orgiin pincde")
        //             selectOriginPincode(isValid.pin_code) ;
        //         }else if(name==='destPincode'){
        //             // console.log("from destPincode pincde")
        //             selectDestPincode(isValid.pin_code);
        //         }

        //         setTimeout(() => {
        //             setIsValidating(false);
        //         }, 0);
        //     }

        // } catch (error) {
        //     console.log(error);
        // }

        try {
            setLoading(true);
            if ("originPincode" === type) {
                setFormValues({
                    ...formValues,
                    'originCity': ''
                });
                const name = 'originCity';
                if (formValues.originPincode.length !== 6) {
                    setLoading(false);
                    return;
                }
                for (const currentValue of pincodeMaster) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_name;
                    if (pincode === formValues.originPincode) {
                        setFormValues({
                            ...formValues,
                            [name]: cityName
                        });
                        setLoading(false);
                        return;
                    }
                }
            } else if ("destPincode" === type) {
                setFormValues({
                    ...formValues,
                    'destCity': ''
                });
                const name = 'destCity';
                if (formValues.destPincode.length !== 6) {
                    setLoading(false);
                    return;
                }
                for (const currentValue of pincodeMaster) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_name;
                    const cityCode = currentValue.city_code;
                    const stateCode = currentValue.state_code;
                    const countryCode = currentValue.country_code;
                    if (pincode === formValues.destPincode) {
                        setFormValues({
                            ...formValues,
                            [name]: cityName,
                            'receiverPincode': pincode,
                            'receiverCity': cityCode,
                            'receiverState': stateCode,
                            'receiverCountry': countryCode
                        });
                        setLoading(false);
                        return;
                    }
                }
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const handleDocTypeChange = (event) => {
        setFormValues({
            ...formValues,
            docType: event.target.value,
            // nonDoxDetails: [{ id: Date.now(), weight: '', len: '', wid: '', ht: '' }] // Reset details when changing doc type
        });
    };

    const addDoxDetail = () => {
        if (formValues.packets && formValues.nonDoxDetails.length < parseInt(formValues.packets)) {
            setFormValues({
                ...formValues,
                nonDoxDetails: [...formValues.nonDoxDetails, { id: Date.now(), weight: '', len: '', wid: '', ht: '' }]
            });
        } else {
            alert(`You can only add up to ${formValues.packets} non-Dox details.`);
        }
    };

    const removeDoxDetail = (id) => {
        setFormValues({
            ...formValues,
            nonDoxDetails: formValues.nonDoxDetails.filter(detail => detail.id !== id)
        });
    };

    const contentList = ["BOOKS", "CAMERA", "CLOTHES", "COMPUTER", "DOCUMENTS", "EARPHONE", "GIFT ITEMS", "LAPTOP", "PRINTERS", "SHOES", "WRIST WATCH", "OTHER"];

    const AIR_DIMENSION = "AR";
    const SURFACE_DIMENSION = "SF"

    async function loadServiceDetails(store) {

        const response = await getServiceDetails(store);
        if (response.length > 0) {
            let lst_service = []
            let i;
            lst_service.push('Select...');
            for (i of response) {
                if (i.service_mode === AIR_DIMENSION || i.service_mode === SURFACE_DIMENSION) {
                    lst_service.push(i.service_group_code);
                    // lst_service.push(i.service_group_name + " - " + i.service_group_code);
                }
            }
            setService(lst_service);
        }
    }

    const [pincodeMaster,setPincodeMaster] = useState([]);
    async function loadPincodeDetails(store) {

        const response = await getPincodeDetails(store);
        if (response.length > 0) {
            let pincode = [];
            let i;
            for (i of response) {
                pincode.push(i.pin_code);
            }

            setPincodeList(pincode);
            setPincodeMaster(response);
            loadClientDetail(store, response);
        }
    }

    async function loadCountryDetails(store) {

        const response = await getCountryDetails(store);
        if (response.length > 0) {
            const country = [];
            let i;
            for (i of response) {
                country.push(i.country_name.toUpperCase() + " | " + i.country_code);
            }
            setCountry(country);
        }
    }

    async function loadAllReceiverDetails(store) {
        const response = await getConsigneeDetails(store);
        if (response.length > 0) {
            let receiverContactNo = [];
            for (const i of response) {
                receiverContactNo.push({ contact_no: i.contact_no, name: i.name, address: i.address, pincode: i.pincode, city_name: i.city_name });
            }
            setReceiver(receiverContactNo);
        }
    }

    async function loadClientDetail(store, pinResponse) {
        const response = await getClientDetail(store);
        console.log(response);
        if (response.length > 0) {
            let pin = "";
            for (const i of response) {
                pin = i.pincode;
                break;
            }

            console.log('pincodemaster',pincodeMaster)
            // --------- set default origin pincode, origin city
            if (pin.trim() !== '') {
                for (const currentValue of pinResponse) {
                    const pincode = currentValue.pin_code;
                    const cityName = currentValue.city_name;
                    if (pin === pincode) {
                        setFormValues({
                            ...formValues,
                            "originPincode": pincode,
                            "originCity": cityName
                        });
                        break;
                    }
                }
            }
        }
    }

    const handleSave = async (e) => {
e.preventDefault();
        if (formValues.clientCode === '') {
            alert('No Client Found');
            return;
        }

        if (formValues.awbNo === '') {
            alert('Please enter awb no.');
            return;
        }
        else if (formValues.service === Select) {
            alert('Please select service');
            return;
        }
        else if (formValues.originCity === '') {
            alert('Please enter correct origin pincode');
            return;
        }
        else if (formValues.domInt === 'dom' && formValues.destCity === '') {
            alert('Please enter correct destination pincode');
            return;
        }
        else if (formValues.domInt === 'int' && formValues.destCountry === '') {
            alert('Please enter correct destination country');
            return;
        }
        // else if (formValues.content === Select) {
        //     alert('Please select correct content');
        //     return;
        // }
        //  else if (formValues.content === 'OTHER' && formValues.otherContent.trim() === '') {
        //     alert('Please enter correct content');
        //     return;
        // }
        else if (formValues.packets === '') {
            alert('Please enter correct No. of Packets');
            return;
        }
        else if (formValues.docType === 'dox' && formValues.weight === '') {
            alert('Please enter correct weight');
            return;
        }
        else if (formValues.docType === 'non-dox' && formValues.nonDoxDetails.length !== parseInt(formValues.packets, 10)) {
            alert('Total No. of packets not matches non-dox items');
            return;
        }
        else if (formValues.receiverContact.trim().length === 0 && (formValues.receiverName.trim().length > 0 || formValues.receiverAddress.trim().length > 0)) {
            alert('Only Receiver Name or Address is not allowed\nPlease also enter receiver contact no.');
            return;
        }

        const isOriginValid = pincodeMaster.find(
                                pin => pin.pin_code === formValues.originPincode
                            );
        if(isOriginValid){
            selectOriginPincode(formValues.originPincode)
        }else{
            alert("Enter valid Origin pincode")
            return;
        }         
        const isDestValid = pincodeMaster.find(
                                pin => pin.pin_code === formValues.destPincode
                            );
        if(isDestValid){
            selectOriginPincode(formValues.destPincode)
        }else{
            alert("Enter valid Destination pincode")
            return;
        }
        // else if (formValues.receiverContact.trim() === '') {
        //     alert('Please enter correct receiver contact');
        //     return;
        // } 
        // else if (formValues.receiverName.trim() === '') {
        //     alert('Please enter correct receiver name');
        //     return;
        // } 
        // else if (formValues.receiverAddress.trim() === '') {
        //     alert('Please enter correct receiver address');
        //     return;
        // }

        if (formValues.docType === 'non-dox') {
            for (const item of formValues.nonDoxDetails) {
                if (item.weight === '') {
                    alert('Please enter weight in non-dox items');
                    return;
                }
            }
        }

        setLoading(true);
        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }
        try {

            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
            const userKey = c[0];
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(formValues),
                    userKey: userKey
                })
            };

            const path = API_PATH + CREDIT_BOOK_PICKUP_REQUEST_PATH + "save";
            const res = await fetch(path, requestOptions);
            const contentType = res.headers.get('Content-Type');

            // Check if the response is likely binary (PDF file or any binary data)
            if (contentType && contentType.includes('application/octet-stream')) {

                const arrayBuffer = await res.arrayBuffer();
                const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                handleReset('');
                window.open(url, '_blank', 'noopener,noreferrer,width=800,height=600,scrollbars=no,resizable=yes');

            } else {

                const data = await res.json();
                const response = data;

                if (response.includes("Entry saved.")) {
                    handleReset('');
                    setModalMessage('Data saved successfully!');
                    setModalType('success');
                    setShowModal(true);

                } else {
                    setModalMessage('Error : ' + response);
                    setModalType('danger');
                    setShowModal(true);
                }
            }

        } catch (error) {
            console.error('Error:', error);
            setModalMessage('Failed to save data. Please try again.');
            setModalType('danger');
            setShowModal(true);
        } finally {
            setLoading(false);
        }
    };

    const handleReset = (awbNo) => {
        setChecked(false)
        setFormValues({
            domInt: formValues.domInt,
            awbNo: awbNo,
            service: formValues.service,
            originPincode: formValues.originPincode,
            originCity: formValues.originCity,
            destPincode: '',
            destCity: '',
            content: '',
            otherContent: '',
            insuranceValue: '',
            packets: '',
            weight: '',
            docType: 'dox',
            nonDoxDetails: [{ id: Date.now(), weight: '', len: '', wid: '', ht: '' }],
            receiverName: '',
            receiverAddress: '',
            receiverContact: '',
            printShiper: '',
            clientCode: getCookie(USER_TYPE_COOKIE_NAME) === US ? getCookie(LOGIN_COOKIE_NAME).split(LOGIN_COOKIE_NAME_SPLITBY)[1] : '',
            userType: getCookie(APP_TYPE_COOKIE_NAME)
        });
        setIsValidating(false);
    };

    const handleEnterAsTab = (e) => {
    if (
        e.key === "Enter" &&
        e.target.tagName !== "TEXTAREA"
    ) {
        e.preventDefault();

        const form = e.target.form;
        const elements = Array.from(form.elements);
        const index = elements.indexOf(e.target);
        if(elements[index].name === 'saveBtn'){
            handleSave(e);
            console.log(elements[index].name)
            elements[0].focus();
            return;
        }
        else if(elements[index].name ==='originPincode'){
            if (
                activeOriginIndex >= 0 &&
                activeOriginIndex < filteredOriginPincodes.length
            ) {
                selectOriginPincode(filteredOriginPincodes[activeOriginIndex]);
            }

            const fieldName = elements[index].name;
            const pincodeValue = formValues[fieldName];

            const isValid = pincodeMaster.find(
                pin => pin.pin_code === pincodeValue
            );

            if (!isValid) {
                elements[index].focus();
                return;
            }
        }
        else if(elements[index].name === 'destPincode'){
            console.log("activeDestIndex",activeDestIndex);
            console.log("filteredDestPincodes[activeDestIndex]",filteredDestPincodes[activeDestIndex]);
            if (
                activeDestIndex >= 0 &&
                activeDestIndex < filteredDestPincodes.length
            ) {
                selectDestPincode(filteredDestPincodes[activeDestIndex]);
            }

            const fieldName = elements[index].name;
            const pincodeValue = formValues[fieldName];

            const isValid = pincodeMaster.find(
                pin => pin.pin_code === pincodeValue
            );

            if (!isValid) {
                elements[index].focus();
                return;
            }
        }
        for (let i = index + 1; i < elements.length; i++) {
            if (
                elements[i].focus &&
                !elements[i].disabled &&
                elements[i].type !== "hidden"
            ) {
                elements[i].focus();
                break;
            }
        }
    }
};

    return (
        <>
            {/* Bootstrap Modal */}
            <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden={!showModal}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {/* <div className={`modal-header alert-${modalType}`}> */}
                        <div className={`modal-header alert-${modalType} d-flex justify-content-between`}>
                            <h5 className="modal-title" id="modalLabel">Alert</h5>
                            <button type="button" className="close" onClick={() => setShowModal(false)} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {modalMessage}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                {loading && <CircularSpinner />}
                <div className="text-center">
                    <h1>PickUp Request</h1>
                </div>
                {/* Consignment Details Section */}
                <section className="border p-3 mb-4">
                    <h2 className="text-primary border-bottom pb-2">Consignment Details</h2>
                    <form onKeyDown={handleEnterAsTab}>
                        <div className="row mb-3 align-items-center">
                            <div className="col-md-2">
                                <label className="form-label small-label">Domestic/International</label>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="dom"
                                        name="domInt"
                                        value="dom"
                                        className="form-check-input small-input"
                                        checked={formValues.domInt === 'dom'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="dom" className="form-check-label" small-label>Domestic</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="int"
                                        name="domInt"
                                        value="int"
                                        className="form-check-input small-input"
                                        checked={formValues.domInt === 'int'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="int" className="form-check-label small-label">International</label>
                                </div>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small-label">
                                    Awb No.
                                    <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="awbNo"
                                    className="form-control small-input"
                                    placeholder="Enter awb no."
                                    value={formValues.awbNo}
                                    onChange={handleInputChange}
                                    onBlur={handleBlurAwbNo}
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small-label">
                                    Origin Pincode
                                    <span className="text-danger">*</span>
                                </label>
                                {/* // For Origin Pincode Input */}
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        name="originPincode"
                                        autoComplete="off"
                                        className="form-control small-input"
                                        placeholder="Enter Origin Pincode..."
                                        value={formValues.originPincode}
                                        onChange={(e) => {
                                            handleInputChange(e);
                                            setActiveOriginIndex(-1); // reset active index when typing
                                        }}
                                        onBlur={(e) => {
                                            // Optionally, delay closing so that click events on list items can register
                                            handleBlur("originPincode");
                                            setTimeout(() => setFilteredOriginPincodes([]), 150);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Tab') {
                                                // Clear the suggestions list and allow default behavior (move focus)
                                                setFilteredOriginPincodes([]);
                                                return;
                                            } else if (e.key === 'ArrowDown') {
                                                e.preventDefault();
                                                setActiveOriginIndex((prev) =>
                                                    prev < filteredOriginPincodes.length - 1 ? prev + 1 : prev
                                                );
                                            } else if (e.key === 'ArrowUp') {
                                                e.preventDefault();
                                                setActiveOriginIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                            } 
                                            // else if (e.key === 'Enter') {
                                            //     e.preventDefault();
                                                // if (
                                                //     activeOriginIndex >= 0 &&
                                                //     activeOriginIndex < filteredOriginPincodes.length
                                                // ) {
                                                //     selectOriginPincode(filteredOriginPincodes[activeOriginIndex]);
                                                // }
                                            // }
                                        }}
                                    />
                                    {filteredOriginPincodes.length > 0 && (
                                        <ul className="autocomplete-list">
                                            {filteredOriginPincodes.map((item, index) => (
                                                <li
                                                    key={index}
                                                    onMouseDown={() => selectOriginPincode(item)}
                                                    className={index === activeOriginIndex ? 'active' : ''}
                                                >
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                {/* <div style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        name="originPincode"
                                        className="form-control"
                                        placeholder="Enter Origin Pincode..."
                                        value={formValues.originPincode}
                                        onChange={handleInputChange}
                                        onBlur={() => handleBlur('originPincode')}
                                    />
                                    {filteredOriginPincodes.length > 0 && (
                                        <ul className="autocomplete-list">
                                            {filteredOriginPincodes.map((item, index) => (
                                                <li key={index} onClick={() => selectOriginPincode(item)}>
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div> */}
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small-label">
                                    Origin City
                                    <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control small-input"
                                    disabled
                                    value={formValues.originCity}
                                />
                            </div>

                            {formValues.domInt === 'dom' && <>
                                <div className="col-md-2">
                                    <label className="form-label small-label">
                                        Destination Pincode
                                        <span className="text-danger">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            type="text"
                                            name="destPincode"
                                            autoComplete="off"
                                            className="form-control small-input"
                                            placeholder="Enter Destination Pincode..."
                                            value={formValues.destPincode}
                                            onChange={(e) => {
                                                handleInputChange(e);
                                                setActiveDestIndex(-1); // reset active index when typing
                                            }}
                                            onBlur={(e) => {
                                                setTimeout(() => setFilteredDestPincodes([]), 150);
                                                handleBlur("destPincode");
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Tab') {
                                                    // Clear the suggestions list and allow default behavior (move focus)
                                                    setFilteredDestPincodes([]);
                                                    return;
                                                } else if (e.key === 'ArrowDown') {
                                                    e.preventDefault();
                                                    setActiveDestIndex((prev) =>
                                                        prev < filteredDestPincodes.length - 1 ? prev + 1 : prev
                                                    );
                                                } else if (e.key === 'ArrowUp') {
                                                    e.preventDefault();
                                                    setActiveDestIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                                } 
                                                // else if (e.key === 'Enter') {
                                                //     e.preventDefault();
                                                //     if (
                                                //         activeDestIndex >= 0 &&
                                                //         activeDestIndex < filteredDestPincodes.length
                                                //     ) {
                                                //         selectDestPincode(filteredDestPincodes[activeDestIndex]);
                                                //     }
                                                // }
                                            }}
                                        />
                                        {filteredDestPincodes.length > 0 && (
                                            <ul className="autocomplete-list">
                                                {filteredDestPincodes.map((item, index) => (
                                                    <li
                                                        key={index}
                                                        onMouseDown={() => selectDestPincode(item)}
                                                        className={index === activeDestIndex ? 'active' : ''}
                                                    >
                                                        {item}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    {/* <div style={{ position: 'relative' }}>
                                        <input
                                            type="text"
                                            name="destPincode"
                                            className="form-control"
                                            placeholder="Enter Destination Pincode..."
                                            value={formValues.destPincode}
                                            onChange={handleInputChange}
                                            onBlur={() => handleBlur('destPincode')}
                                        />
                                        {filteredDestPincodes.length > 0 && (
                                            <ul className="autocomplete-list">
                                                {filteredDestPincodes.map((item, index) => (
                                                    <li key={index} onClick={() => selectDestPincode(item)}>
                                                        {item}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div> */}
                                </div>

                                <div className="col-md-2">
                                    <label className="form-label small-label">
                                        Destination City
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control small-input "
                                        disabled
                                        value={formValues.destCity}
                                    />
                                </div>
                            </>}

                            {formValues.domInt === 'int' && (
                                <>
                                    <div className="col-md-2" style={{ position: 'relative' }}>
                                        <label className="form-label small-label">
                                            Destination Country
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="destCountry"
                                            autoComplete="off"
                                            className="form-control small-input"
                                            placeholder="Enter Destination Country..."
                                            value={formValues.destCountry}
                                            onBlur={() => {
                                                setTimeout(() => setFilteredCountries([]), 150);
                                                handleBlurCountry('destCountry');
                                            }}
                                            onChange={handleInputChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Tab') {
                                                    setFilteredCountries([]);
                                                    return;
                                                } else if (e.key === 'ArrowDown') {
                                                    e.preventDefault();
                                                    setActiveCountryIndex((prev) =>
                                                        prev < filteredCountries.length - 1 ? prev + 1 : prev
                                                    );
                                                } else if (e.key === 'ArrowUp') {
                                                    e.preventDefault();
                                                    setActiveCountryIndex((prev) => (prev > 0 ? prev - 1 : 0));
                                                } else if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    if (
                                                        activeCountryIndex >= 0 &&
                                                        activeCountryIndex < filteredCountries.length
                                                    ) {
                                                        selectCountry(filteredCountries[activeCountryIndex]);
                                                    }
                                                }
                                            }}
                                        />
                                        {filteredCountries.length > 0 && (
                                            <ul className="autocomplete-list">
                                                {filteredCountries.map((item, index) => (
                                                    <li
                                                        key={index}
                                                        onMouseDown={() => selectCountry(item)}
                                                        className={index === activeCountryIndex ? 'active' : ''}
                                                    >
                                                        {item}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                    {/* <div className="col-md-2">
                                        <label className="form-label">Destination Country</label>
                                        <input
                                            type="text"
                                            name="destCountry"
                                            autoComplete="off"
                                            className="form-control"
                                            placeholder="Enter Destination Country..."
                                            value={formValues.destCountry}
                                            onBlur={() => handleBlurCountry('destCountry')}
                                            onChange={handleInputChange}
                                            list="countries" // Link to the datalist
                                        />
                                        <datalist id="countries">
                                            {country.map((countryItem, index) => (
                                                <option key={index} value={countryItem} /> // Only show the country name
                                            ))}
                                        </datalist>
                                    </div> */}
                                </>
                            )}


                        </div>

                        <div className="row mb-3 align-items-center">
                            <div className="col-md-2">
                                <label className="form-label small-label">
                                    Service
                                    <span className="text-danger">*</span>
                                </label>
                                <select
                                    name="service"
                                    className="form-select small-input"
                                    value={formValues.service}
                                    onChange={handleInputChange}
                                >
                                    {service.map((item, index) => (
                                        <option key={index} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small-label">Content</label>
                                <select
                                    name="content"
                                    className="form-select small-input"
                                    value={formValues.content}
                                    onChange={handleInputChange}
                                >
                                    <option>Select...</option>
                                    {contentList.map((itemcontent, index) => (
                                        <option key={index} value={itemcontent}>
                                            {itemcontent}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {formValues.content === 'OTHER' && (
                                <div className="col-md-2">
                                    <label className="form-label small-label">Other Content</label>
                                    <input
                                        type="text"
                                        name="otherContent"
                                        className="form-control small-input"
                                        placeholder="Enter content..."
                                        value={formValues.otherContent}
                                        onChange={handleInputChange}
                                        ref={otherContentRef} // Attach the ref here
                                    />
                                </div>
                            )}

                            <div className="col-md-2">
                                <label className="form-label small-label">
                                    Invoice Value
                                </label>
                                <input
                                    type="text"
                                    name="insuranceValue"
                                    className="form-control small-input"
                                    placeholder="Enter invoice value..."
                                    value={formValues.insuranceValue}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small-label">
                                    No. of Packets
                                    <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="packets"
                                    className="form-control small-input"
                                    placeholder="Enter no. of packets..."
                                    value={formValues.packets}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label small-label">Shipment Type</label>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="dox"
                                        name="docType"
                                        value="dox"
                                        className="form-check-input small-label"
                                        checked={formValues.docType === 'dox'}
                                        onChange={handleDocTypeChange}
                                    />
                                    <label htmlFor="dox" className="form-check-label">Dox</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        id="non-dox"
                                        name="docType"
                                        value="non-dox"
                                        className="form-check-input small-label"
                                        checked={formValues.docType === 'non-dox'}
                                        onChange={handleDocTypeChange}
                                    />
                                    <label htmlFor="non-dox" className="form-check-label small-label">Non-Dox</label>
                                </div>
                            </div>


                            {formValues.docType === 'dox' && (
                                <div className="col-md-2">
                                    <label className="form-label small-label">
                                        Weight
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="weight"
                                        className="form-control small-input"
                                        placeholder="Enter weight..."
                                        value={formValues.weight}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            )}
                        </div>

                        {/* Conditionally render the Non-Dox details section */}
                        {formValues.docType === 'non-dox' && (
                            <div className="border p-3 mb-3">
                                <h5>Non-Dox Details</h5>
                                {formValues.nonDoxDetails.map(detail => (
                                    <div className="row mb-2" key={detail.id}>
                                        <div className="col-md-2">
                                            <label className="form-label small-label">
                                                Weight
                                                <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name={`detail-${detail.id}-weight`} // Updated name
                                                className="form-control small-input"
                                                placeholder="Enter weight..."
                                                value={detail.weight}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small-label">Length</label>
                                            <input
                                                type="text"
                                                name={`detail-${detail.id}-len`} // Updated name
                                                className="form-control small-input"
                                                placeholder="Enter length..."
                                                value={detail.len}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small-label">Width</label>
                                            <input
                                                type="text"
                                                name={`detail-${detail.id}-wid`} // Updated name
                                                className="form-control small-input"
                                                placeholder="Enter width..."
                                                value={detail.wid}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small-label">Height</label>
                                            <input
                                                type="text"
                                                name={`detail-${detail.id}-ht`} // Updated name
                                                className="form-control small-input"
                                                placeholder="Enter height..."
                                                value={detail.ht}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-1 d-flex align-items-end mt-2">
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => removeDoxDetail(detail.id)}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={addDoxDetail}
                                            disabled={!formValues.packets || formValues.nonDoxDetails.length >= parseInt(formValues.packets)}
                                        >
                                            Add Non-Dox Details
                                        </button>
                                    </div>
                                )}

                                <section className="border p-3">
                            <h2 className="text-primary border-bottom pb-2">Receiver Details</h2>
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <label className="form-label small-label ">Receiver Phone No.</label>
                                    <input
                                        type="text"
                                        name="receiverContact"
                                        className="form-control small-input"
                                        value={formValues.receiverContact}
                                        onBlur={() => handleBlurReceiver('receiverContact')}
                                        onChange={handleInputChange}
                                        placeholder="Enter Receiver Phone No."
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label small-label">Receiver Name</label>
                                    <input
                                        type="text"
                                        name="receiverName small-input"
                                        className="form-control"
                                        value={formValues.receiverName}
                                        onChange={handleInputChange}
                                        placeholder="Enter Receiver Name"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label small-label">Receiver Address</label>
                                    <input
                                        type="text"
                                        name="receiverAddress"
                                        className="form-control small-input"
                                        value={formValues.receiverAddress}
                                        onChange={handleInputChange}
                                        placeholder="Enter Receiver Address"
                                    />
                                </div>
                            </div>
                        </section>

                        {/* Save and Reset Buttons */}
                        <div className="p-4">
                            <label className="checkshiper" >
                                <input
                                    type="checkbox"
                                    name="printShiper"
                                    checked={checked}
                                    onChange={handleInputChange}
                                    className="w-4 h-4"
                                />
                                <span>   Print shipper</span>
                            </label>
                        </div>


                        <div className="d-flex justify-content-end mt-4">
                            <button type="button" className="btn btn-primary me-2" name='saveBtn' onClick={handleSave}>
                                Save
                            </button>
                            <button type="button" className="btn btn-secondary" onClick={() => handleReset('')}>
                                Reset
                            </button>
                        </div>

                    </form>
                </section>

                {/* Receiver Details Section */}
                
                <br />
                <br />
            </div>
        </>
    );
};
